/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import PrimaryLargeButton from "../../../components/_utils/CommonButtons/PrimaryLargeButton";
import PasswordInputField from "../../../components/_utils/CommonInputFields/PasswordInputField";
import TextInputField from "../../../components/_utils/CommonInputFields/TextInputField";
import IpAddressErrorPage from "../../../components/_utils/IpAddressErrorPage";
import axiosInstance from "../../../redux/globalInspector/axiosInstance";
import {
  loginNewToken,
  resetChangePassword,
  resetLoginError,
} from "../../../redux/features/login/login";
import {
  disabledEnabledError,
  removeInitialError,
} from "../../../redux/features/totp/totp";
import LoginTotp from "../../LoginTotp/LoginTotp";
import {
  resetMultiEntityAllMappingsData,
  multiEntityAllMappings,
} from "../../../redux/features/multientity/multientity";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
import PrimaryWithIconButton from "../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import CommonAlertCard from "../../../components/_utils/CommonAlertCard";

const Relogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let store = sessionStorage.getItem("previousLog") || "/home";

  const [ipError, setIpError] = useState(false);
  const [isReLoggingIn, setIsReLoggingIn] = useState(false);
  const [isReLoginError, setIsReLoginError] = useState("");
  const [isCredentialsFilled, setIsCredentialsFilled] = useState(false);

  const [cred, setCred] = useState(() => {
    const prefillUserId = sessionStorage.getItem("prefillUserId") || "";
    sessionStorage.removeItem("subEntitySelected");
    return {
      user_Id: prefillUserId,
      password: "",
      totp: "",
      type: "",
    };
  });

  const entityData = useSelector((state) => state.login.data);

  const { isLoading, loginErrorMessage, isError } = useSelector(
    (state) => state.login,
  );

  const [flag, setFlag] = useState(true);
  const [isFocus, setIsFocus] = useState(false);
  const [isBackupCodes, setIsBackupCodes] = useState(false);

  const handleFetch = async () => {
    try {
      const ipAddress = await axiosInstance.get(
        "https://nxt.api.q2pay.in/api/utilities/whatismyip",
      );
      if (ipAddress?.data?.ip) {
        setIpError(false);
      }
    } catch (error) {
      setIpError(true);
    }
  };

  let queryParams = {
    page_no: 1,
    page_size: 100,
    search_string: "",
    favourite: "",
  };

  let queryParamsFav = {
    page_no: 1,
    page_size: 100,
    search_string: "",
    favourite: "Y",
  };

  useLayoutEffect(() => {
    dispatch(resetLoginError());
  }, [flag]);

  const handleChangeUname = (e) => {
    const { value } = e.target;
    const sanitizedValue = value.trim();

    setCred((prevCred) => {
      return {
        ...prevCred,
        user_Id: sanitizedValue,
      };
    });
    setIsReLoginError(false);
  };
  const handleChangePwd = (e) => {
    const { value } = e.target;
    const sanitizedValue = value.trim();

    setCred((prevCred) => {
      return {
        ...prevCred,
        password: sanitizedValue,
      };
    });
    setIsReLoginError(false);
  };

  // const handleEnterKeyPress = (e) => {
  //   if (e.key === "Enter" && isCredentialsFilled) {
  //     handleReLogin();
  //   }
  // };

  const handleEnterKeyPress = (e) => {
    if (e.key !== "Enter") return;

    const { type, totp } = cred || {};

    if (type === "totp") {
      if (totp?.length === 6 && !isError) {
        handleReLogin();
      }
      return;
    }

    if (type === "backup") {
      if (totp?.length === 7 && !isError) {
        handleReLogin();
      }
      return;
    }

    if (!isReLoginError && isCredentialsFilled && type === "") {
      handleReLogin();
    }
  };

  const handleReLogin = async () => {
    sessionStorage.removeItem("selectedCards");
    if (!isCredentialsFilled) return;
    sessionStorage.removeItem("primaryEntityData");
    sessionStorage.removeItem("primary_entity_data");
    sessionStorage.removeItem("favourite_entities");

    setIsReLoggingIn(true);

    try {
      const response = await dispatch(loginNewToken(cred));
      const loginData = response?.payload;
      const employee = loginData?.employees;

      const canConciergeLogin = employee?.can_concierge_login === "Y";
      const isFirstLogin = employee?.first_login_flag === "Y";
      const userId = employee?.user_id;

      let multiEntityData = null;
      let isPrimary = false;
      let fav;

      if (canConciergeLogin) {
        const results = await Promise.allSettled([
          Promise.resolve(response),
          dispatch(multiEntityAllMappings({ ...queryParams, userId })),
          dispatch(multiEntityAllMappings({ ...queryParamsFav, userId })),
        ]);

        const multiEntityResult = results[1];

        if (multiEntityResult.status === "fulfilled") {
          multiEntityData = multiEntityResult.value?.payload;
          isPrimary = multiEntityData?.mappings?.some(
            (val) => val?.primary_user === userId,
          );
          fav = multiEntityData?.mappings?.filter((val) => {
            return val?.favourite === "Y";
          });
        } else {
          console.warn("Multi-entity API failed:", multiEntityResult.reason);
        }
      }

      dispatch(removeInitialError());
      dispatch(disabledEnabledError());

      if (loginData?.status === true) {
        if (isFirstLogin) {
          navigate("/setNewPassword");
        } else if (cred?.type === "backup") {
          sessionStorage.removeItem("previousLog");
          navigate("/settings/security_center/TOTP_Setup", { replace: true });
          setTimeout(() => {
            CommonToast({
              text: "Logged in successfully using backup codes",
              icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
            CommonToast({
              text: "TOTP has been disabled",
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }, 300);
        } else {
          if (!canConciergeLogin || (canConciergeLogin && !isPrimary)) {
            sessionStorage.setItem("suppressPullTab", "true");
          } else {
            sessionStorage.setItem(
              "primary_entity_data",
              JSON.stringify(loginData),
            );
            sessionStorage.setItem("favourite_entities", JSON.stringify(fav));
          }

          navigate(store, { replace: true, state: true });
          sessionStorage.removeItem("previousLog");
          dispatch(resetMultiEntityAllMappingsData());
        }
      } else {
        setIsReLoginError("Invalid username or password.");
      }
    } catch (error) {
      setIsReLoginError("Something went wrong. Please try again.");
    } finally {
      setIsReLoggingIn(false);
    }
  };
  useEffect(() => {
    dispatch(resetChangePassword());
    const storedUserId = sessionStorage.getItem("user_id") || "";
    setCred((prevCred) => ({ ...prevCred, user_Id: storedUserId }));
    sessionStorage.removeItem("suppressPullTab");
    if (!sessionStorage.getItem("q2p_token")) {
      sessionStorage.removeItem("previousLog");
    }

    if (
      store === "/multi_entity" ||
      store === "/multi_entity_viewAll" ||
      store === "/feature_not_assigned" ||
      store === "/*"
    ) {
      sessionStorage.setItem("previousLog", "/home");
    }
    handleFetch();
  }, []);

  useEffect(() => {
    setIsCredentialsFilled(
      cred.user_Id.trim() !== "" && cred.password.trim() !== "",
    );
    document.addEventListener("keypress", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keypress", handleEnterKeyPress);
    };
  }, [cred, isReLoginError, isCredentialsFilled, isError]);
  useEffect(() => {
    if (!isLoading) {
      if (loginErrorMessage === "Invalid TOTP code") {
        setFlag(false);
      }
    }
  }, [loginErrorMessage]);

  return (
    <>
      {ipError ? (
        <>
          <IpAddressErrorPage handleFetch={handleFetch} />
        </>
      ) : (
        <div
          className="h-screen flex justify-center"
          style={{
            backgroundImage:
              "url('https://q2pay.in/new_assets/graphics/login/backgrond_for_login.svg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {flag === true ? (
            <div className="w-full h-full grid place-items-center  Qlg:p-padding-base p-padding-sm">
              <div className="w-full Qsmd:w-fit rounded-border-radius-md p-[var(--border)] bg-[linear-gradient(154.44deg,rgba(97,117,153,0.5)_16.18%,rgba(100,100,100,0.5)_100.4%)] shadow-[0px_4px_4px_0px_#00000033]">
                <div className="Qsmd:p-padding-xl px-padding-sm py-padding-lg rounded-border-radius-md bg-primary-bg Qsmd:w-[var(--login-card-height)] w-full  h-fit">
                  <div className="flex flex-col gap-gap-xl items-center">
                    <div className="w-xpentra-logo-width-login h-[var(--gap-lg)]">
                      <img
                        src={ICONS?.XPENTRA_WHITE}
                        alt=""
                      />
                    </div>
                    <CommonAlertCard
                      title={"Session timed out!"}
                      texts={
                        "Your session has expired due to inactivity. Please log in again to continue."
                      }
                    />
                    <div className="flex flex-col gap-gap-md items-center justify-between w-full ">
                      <TextInputField
                        bgColor="var(--primary-bg)"
                        placeholderColor="var(--text-secondary)"
                        fgColor="var(--text-secondary)"
                        placeholder="User ID / Alias"
                        variant={isReLoginError ? "error" : "default"}
                        fontKind="big"
                        value={cred.user_Id}
                        onInput={handleChangeUname}
                        isFullWidth={true}
                      />
                      <div className="w-full">
                        <PasswordInputField
                          bgColor="var(--primary-bg)"
                          fgColor="var(--text-secondary)"
                          placeholder="Password"
                          variant={isReLoginError ? "error" : "default"}
                          fontKind="big"
                          value={cred.password}
                          onInput={handleChangePwd}
                          isFullWidth={true}
                        />
                        <div
                          className="text-pending cursor-pointer text-font-sm mt-margin-sm w-fit"
                          onClick={() => navigate("/contactAdmin")}
                        >
                          Forgot your password?
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex flex-col gap-gap-md items-center">
                      <div className="w-full flex justify-center">
                        <PrimaryLargeButton
                          btnType="button"
                          btnText="Login"
                          hoverOption="black"
                          enabledBgColor="var(--positive-act)"
                          enabledTextColor="var(--text-primary)"
                          disabledBgColor="var(--text-disabled)"
                          disabledTextColor="var(--text-primary)"
                          isDisabled={isReLoginError || !isCredentialsFilled}
                          handleFunction={(e) => {
                            if (
                              isReLoginError ||
                              !isCredentialsFilled ||
                              isReLoggingIn
                            )
                              return;
                            handleReLogin(e);
                          }}
                          isLoaderNeeded={true}
                          isLoading={isReLoggingIn}
                          isFillNeeded={true}
                          inActiveVariantNeeded={true}
                        />
                      </div>
                      {isReLoginError ? (
                        <div className="mt-margin-md flex flex-col items-start w-full gap-gap-sm">
                          <h1 className="text-font-lg text-text-primary font-semibold">
                            Unable to login!
                          </h1>

                          <h2 className="text-font-sm text-text-primary font-semibold mt-margin-md">
                            Possible reasons:
                          </h2>

                          <ul className="list-disc pl-5 flex flex-col gap-gap-sm">
                            <li className="text-text-primary text-font-xs">
                              Incorrect / Unauthorized User ID
                            </li>

                            <li className="text-text-primary text-font-xs">
                              Incorrect Password
                            </li>

                            <li className="text-text-primary text-font-xs">
                              Both User ID and Password are incorrect
                            </li>

                            <li className="text-text-primary text-font-xs">
                              Account is blocked
                            </li>
                          </ul>
                        </div>
                      ) : (
                        <>
                          {/* <p className="text-text-secondary font-normal text-font-sm">
                            or login with
                          </p>
                          <div className="flex gap-gap-sm">
                            <PrimaryWithIconButton
                              btnText="Google"
                              enabledBgColor="var(--primary-bg)"
                              isDisabled={true}
                              handleFunction={() => {}}
                              iconToBeAlign="left"
                              enabledTextColor={"var(--text-primary)"}
                              icon={ICONS?.GOOGLE}
                              fullWidthRequired={true}
                              hoverOption="white"
                              outLineColor={"var(--primary-nav)"}
                            />
                            <PrimaryWithIconButton
                              btnText="Microsoft"
                              enabledBgColor="var(--primary-bg)"
                              isDisabled={true}
                              handleFunction={() => {}}
                              iconToBeAlign="left"
                              enabledTextColor={"var(--text-primary)"}
                              icon={ICONS?.MICROSOFT}
                              fullWidthRequired={true}
                              hoverOption="white"
                              outLineColor={"var(--primary-nav)"}
                            />
                          </div> */}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="log-top-div">
              <LoginTotp
                isFocus={isFocus}
                setIsFocus={setIsFocus}
                isLoading={isLoading}
                data={entityData}
                isError={isError}
                handleLogin={handleReLogin}
                handleKeyPress={handleEnterKeyPress}
                cred={cred}
                setCred={setCred}
                isBackupCodes={isBackupCodes}
                setIsBackupCodes={setIsBackupCodes}
              />
            </div>
          )}
          {/* <div className="hidden Qlg:d-flex flex-container text-center text-md-start gap-gap-md items-center fixed bottom-bottom-base Qsmd:mb-margin-lg mb-margin-xl">
            <div className="text-text-primary text-xs items-center">
              © Copyright {new Date().getFullYear()} Q2Pay Technologies Pvt Ltd.
              All rights reserved <span className="mx-margin-xs">|</span>
              <Link
                className="text-pending"
                to="/aboutus"
              >
                About Us
              </Link>
              <span className="mx-margin-xs">|</span>
              <Link
                className="text-pending"
                to="/privacy_policy"
              >
                Privacy
              </Link>
              <span className="mx-margin-xs">|</span>
              <Link
                className="text-pending"
                to="/terms_conditions"
              >
                Terms
              </Link>
            </div>
            <div className="text-text-primary text-xs items-center">
              <div
                tag="a"
                color="none"
                className="mx-margin-sm"
                style={{ color: "var(--text-primary)" }}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://ssl.comodo.com/ev-ssl-certificates.php"
                >
                  <img
                    src={
                      "https://q2pay.in/new_assets/web/sectigo_trust_seal.png"
                    }
                    alt="trust_icon"
                    className="img-fluid"
                    style={{
                      margin: "auto",
                      display: "block",
                      width: "42px",
                      height: "17px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div> */}
        </div>
      )}
    </>
  );
};

export default Relogin;
